/* eslint-disable prefer-template */
import React from 'react';
import { Field } from 'formik';
import { useQuery } from '@apollo/client';
import ReactSelect from 'components/Fields/ReactSelect';
import Loader from 'components/common/Loader';
import { GET_UNASSIGNED_VENDORS } from 'pages/Staff/StaffgraphQL';

const TraderField = (props) => {
  const { data, loading, error } = useQuery(GET_UNASSIGNED_VENDORS, {
    variables: {
      pageNo: 0,
      pageSize: 1000,
    },
    fetchPolicy: 'network-only',
  });

  if (loading) return <Loader size="sm" />;
  if (error) return `There is an error on this page : ${error.message} `;

  return (
    <div>
      <Field
        component={ReactSelect}
        data={
          data?.getUnassignedVendors?.vendors?.filter(
            (v) => v?.vendorName && v.vendorName.trim() !== '',
          ) || []
        }
        keys={{ id: 'id', label: 'label' }}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) =>
          option.vendorName
            ? `${option.vendorName}${option.phone ? ' - ' + option.phone : ''}`
            : ''
        }
        {...props}
      />
    </div>
  );
};

export default TraderField;